import React from 'react';

class NotFound extends React.Component {
    
    render() {
        return (
            <div className="nfwrapper">
                <div className="notfound">
                            <div className="bg-404">404</div>
                            <div className="text-404">404</div>    
                        <h1>Page Not Found</h1>
                </div>
            </div>
        )
    }
}

export default NotFound